export default "__VITE_ASSET__B3$ptBgJ__"